import { render, staticRenderFns } from "./ClusterDashboard.vue?vue&type=template&id=4fb2303e"
import script from "./ClusterDashboard.vue?vue&type=script&lang=js"
export * from "./ClusterDashboard.vue?vue&type=script&lang=js"
import style0 from "./ClusterDashboard.vue?vue&type=style&index=0&id=4fb2303e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports